import React, { useEffect, useCallback, useRef, useState, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import KanBoIcon from 'components/KanBoIcon'
import Loader from 'components/Loader'
import {
  ListItem
} from 'components/List'
import Content from '../../Content'
import ElementContentIcon from '../../ContentIcon'
import Scrollbars from 'components/Scrollbars'
import {
  ContentHeader,
  ContentTitle,
  ContentIcon,
  ContentButton,
} from 'components/Content'
import {
  ToggleModal,
  ModalMenu
} from 'components/Modal'
import {
  MenuItem
} from 'components/Menu'
import { useDispatch } from 'react-redux'
import useGetData from 'hooks/useGetData'
import classes from './MyBoard.module.scss'
import fetchIsCardInMyBoard from '../../sagas/fetchIsCardInMyBoard'
import requestChangeMyBoardList from '../../sagas/requestChangeMyBoardList'
import requestAddToMyBoard from '../../sagas/requestAddToMyBoard'
import requestRemoveFromMyBoard from '../../sagas/requestRemoveFromMyBoard'
 
const MyBoard = ({
  cardContext,
  isCardInMyBoard,
  myBoard,
  isLoading,
  isLoaded,
  currentUserId
}) => {
  const dispatch = useDispatch()

  const toggleModalRef = useRef()

  const [showListSelect, setShowListSelect] = useState(false)

  useEffect(() => {
    if (!isLoaded && !isLoading) {
      dispatch(fetchIsCardInMyBoard({
        cardId: cardContext.id
      }))
    }
  }, [cardContext.id, isLoaded, isLoading])

  const {
    data,
  } = useGetData(showListSelect ? 'MyBoardLists' : undefined)

  const closeListSelect = useCallback(() => {
    toggleModalRef.current.close()
  }, [])

  const handleModalToggle = useCallback((showListSelect) => {
    setShowListSelect(showListSelect)
  }, [])

  const handleAddToMyBoardClick = useCallback(() => {
    dispatch(requestAddToMyBoard({
      cardId: cardContext.id
    }))
  }, [cardContext.id])

  const handleRemoveFromMyBoardClick = useCallback(() => {
    dispatch(requestRemoveFromMyBoard({
      cardId: cardContext.id
    }))
  }, [cardContext.id])

  const isBusy = useMemo(() => isLoading || (isCardInMyBoard && !myBoard), [isLoading, isCardInMyBoard, myBoard])

  return (
    <Content>
      <ContentHeader
        onClick={!isCardInMyBoard ? handleAddToMyBoardClick : null}
      >
        <ElementContentIcon
          className={isCardInMyBoard ? 'text-primary' : null}
        >
          {isBusy &&
            <KanBoIcon spin name='kanbo-16-loading' />
          }
          {!isBusy &&
            <KanBoIcon
              name={isCardInMyBoard ? 'kanbo-24-my-kanbo-board' : 'kanbo-24-not-in-my-board'}
            />
          }
        </ElementContentIcon>
        <ContentTitle>
          {!isCardInMyBoard &&
            <FormattedMessage id='CARD_MYBOARD_NOT_ADDED' />
          }
          {isCardInMyBoard &&
            <Link to={'/myboard/' + currentUserId}>
              <FormattedMessage id='CARD_MYBOARD_ADDED' />
            </Link>
          }
        </ContentTitle>
        {(!isBusy && isCardInMyBoard) &&
          <ModalMenu>
            <ContentIcon>
              <KanBoIcon name='kanbo-16-options' />
            </ContentIcon>
            <MenuItem
              icon={<KanBoIcon name='kanbo-16-remove' />}
              onClick={handleRemoveFromMyBoardClick}
            >
              <FormattedMessage id='CARD_MYBOARD_REMOVE' />
            </MenuItem>
          </ModalMenu>
        }
      </ContentHeader>
      {(isCardInMyBoard && !!myBoard) &&
        <ToggleModal
          backdrop
          ref={toggleModalRef}
          onToggle={handleModalToggle}
          attachment='top center'
          targetAttachment='top center'
          constraints={[
            {
              to: 'window',
              pin: true
            }
          ]}
        >
          <ContentButton>
            <ContentIcon>
              <KanBoIcon name='kanbo-16-list' />
            </ContentIcon>
            <ContentTitle>
              {myBoard.vListName}
            </ContentTitle>
          </ContentButton>
          <Scrollbars
            className={classes.modal}
          >
            {!data ? (
              <ListItem>
                <Loader center />
              </ListItem>
            ) : (
              data.Lists.map(List => {
                const isSelected = List.Id === myBoard.vListId

                const onListClick = () => {
                  dispatch(requestChangeMyBoardList({
                    cardId: cardContext.id,
                    vListId: List.Id
                  }))

                  closeListSelect()
                }

                return (
                  <ListItem
                    key={List.Id}
                    active={isSelected}
                    onClick={onListClick}
                  >
                    {List.Name}
                  </ListItem>
                )
              })
            )}
          </Scrollbars>
        </ToggleModal>
      }
    </Content>
  )
}

export default MyBoard
